import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";
const snapshot = () => window.matchMedia(QUERY).matches;
const subscribe = (onChange) => {
    const media = window.matchMedia(QUERY);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
};

export const useMotionPreference = () => useSyncExternalStore(subscribe, snapshot, () => true);